import { render, staticRenderFns } from "./RegisterOrUploadIso.vue?vue&type=template&id=cc30c452&scoped=true&"
import script from "./RegisterOrUploadIso.vue?vue&type=script&lang=js&"
export * from "./RegisterOrUploadIso.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrUploadIso.vue?vue&type=style&index=0&id=cc30c452&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30c452",
  null
  
)

export default component.exports